import { observer } from 'mobx-react';
import React from 'react';
import { BrowseNavigationItemSelected, BrowseNavigationItemStyle, BrowseNavigationItemType } from '@udemy/browse-event-tracking';
import { Tracker } from '@udemy/event-tracking';
import { useI18n } from '@udemy/i18n';
import { Icon } from '@udemy/icons';
import { AIAssistantEntryPointSelected, LearningAssistantChatTypeOptions, LearningAssistantEntryPointUIRegionOptions } from '@udemy/react-learning-assistant-entry-points';
import { AI_ELEVATE_NAV } from '../../../browse-constants';
import { isAiAssistantEntryPointEnabled } from '../../../external/header-experiment-features';
import { useHeaderExperimentFeatures } from '../../../hooks/use-header-experiment-features';
import { useHeaderStore } from '../../../hooks/use-header-store';
import { MobileNavItem, MobileNavSection, MobileNavSectionHeading } from '../mobile-nav.react-component';
import styles from "./mobile-ai-assistant-nav.module.css";
export const MobileAIAssistantNav = observer(({
  showAIElevateEntryPoint = false,
  shouldEnableAIAssistant = false
}) => {
  const headerStore = useHeaderStore();
  const {
    gettext
  } = useI18n();
  const shouldShowAiAssistantEntryPoint = isAiAssistantEntryPointEnabled({
    headerExperimentFeatures: useHeaderExperimentFeatures(),
    headerStore
  });
  const handleClick = () => {
    Tracker.publishEvent(new AIAssistantEntryPointSelected({
      chatType: LearningAssistantChatTypeOptions.DISCOVERY_CHAT,
      uiRegion: LearningAssistantEntryPointUIRegionOptions.HEADER_NAV
    }));
  };
  const handleAIElevateClick = () => {
    const context = {
      type: BrowseNavigationItemType.AI_COURSES,
      id: '-1',
      style: BrowseNavigationItemStyle.NAVIGATION_DROPDOWN,
      uiRegion: 'main_nav'
    };
    Tracker.publishEvent(new BrowseNavigationItemSelected(context));
  };
  const aiElevateItem = AI_ELEVATE_NAV(gettext).AI_COURSES;
  if (!showAIElevateEntryPoint && !shouldEnableAIAssistant && !shouldShowAiAssistantEntryPoint) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, showAIElevateEntryPoint && /*#__PURE__*/React.createElement(MobileNavSectionHeading, null, gettext('Learn AI')), /*#__PURE__*/React.createElement(MobileNavSection, null, showAIElevateEntryPoint && /*#__PURE__*/React.createElement(MobileNavItem, {
    onClick: handleAIElevateClick,
    href: aiElevateItem.absolute_url,
    key: `mobile-nav-item-ai-courses`
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['ai-courses-nav-item']
  }, /*#__PURE__*/React.createElement("span", null, aiElevateItem.title))), (shouldEnableAIAssistant || shouldShowAiAssistantEntryPoint) && /*#__PURE__*/React.createElement(MobileNavItem, {
    onClick: handleClick,
    href: headerStore.urls.AI_ASSISTANT,
    key: `mobile-nav-item-ai-assistant`
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['ai-assistant-nav-item']
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "sparkles",
    size: 'xsmall',
    color: "info",
    label: false
  }), /*#__PURE__*/React.createElement("span", null, gettext('AI Assistant'))))));
});
//# sourceMappingURL=mobile-ai-assistant-nav.react-component.js.map